import React from 'react';
import PlaceholderGraph from 'rsuite/cjs/Placeholder/PlaceholderGraph';

import {ISummaryHttpMonitors} from 'features/http';

import SummaryMonitors from '../SummaryMonitors/SummaryMonitors';
import LastIncidents from '../LastIncidents/LastIncidents';

import styles from './Dashboard.module.scss';

import type {ISummaryHome} from 'entities/monitor';

interface IDashboardProps {
    summaryMonitors?: ISummaryHttpMonitors,
    isLoadingMonitors: boolean,
    isFetchingMonitors: boolean,
    home?: ISummaryHome,
}

const Dashboard: React.FC<IDashboardProps> = ({
    summaryMonitors,
    isLoadingMonitors,
    isFetchingMonitors,
    home,
}) => (
    <div className={styles.wrapper}>
        {
            (!isLoadingMonitors && summaryMonitors)
                ? <SummaryMonitors
                    summary={summaryMonitors}
                    isFetching={isFetchingMonitors}
                />
                : <PlaceholderGraph active height={356}/>
        }
        <LastIncidents home={home}/>
    </div>
);

export default Dashboard;
